import { Injector } from '@angular/core';
import {
  ActionButtonOutcomesType,
  APP_ZONES,
  BaseWidgetProperties,
} from '@finxone-platform/shared/sys-config-types';
import { InvitationService } from '../../../services/invitation-service/invitation.service';
import { CtaButtonSignalService } from '../../../services/cta-button-signal-service/cta-button-signal.service';
import { handleRedirection } from '../cta-redirection.utils';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { UpdateFormDataActionWithId } from '../../../actions/form-submission.action';
import { FormID } from '@finxone-platform/form-action';
import { AlertHandlerService } from '@finxone-platform/shared/services';

export function acceptJointAccountRequest(injector: Injector, widgetProperties: BaseWidgetProperties): void {
  const invitationService = injector.get(InvitationService);
  const ctaButtonSignalService = injector.get(CtaButtonSignalService);
  const router = injector.get(Router);
  const store = injector.get(Store);
  const alertHandlerService = injector.get(AlertHandlerService);

  const ctaAction = widgetProperties.buttonActionType as string;
  const invitationId = sessionStorage.getItem('jointAccountInvitationId');
  const actionNavigationConfigurations = widgetProperties.actionNavigationConfigurations;
  const zone = router.url.split('/')[2];

  if (!invitationId) {
    console.error('Invitation ID not found');
    return;
  }

  ctaButtonSignalService.setSignal({ [ctaAction]: false });

  const isLoggedOutZone =
    zone === APP_ZONES.ONBOARDING ||
    zone === APP_ZONES.ORGANISATION_ONBOARDING ||
    zone === APP_ZONES.ORGANISATION_VERIFICATION;

  if (isLoggedOutZone) {
    store.dispatch(
      new UpdateFormDataActionWithId({ jointAccountInvitationAccepted: true }, FormID.ONBOARDING_FLOW),
    );
    if (actionNavigationConfigurations?.[ActionButtonOutcomesType.ALTERNATE_1]) {
      handleRedirection(
        widgetProperties,
        injector,
        ActionButtonOutcomesType.ALTERNATE_1,
        true,
        isLoggedOutZone,
      );
    }
    return;
  }

  invitationService.acceptInvitation(invitationId).subscribe({
    next: () => {
      sessionStorage.removeItem('jointAccountInvitationId');
      sessionStorage.removeItem('jointAccountInvitationToken');
      ctaButtonSignalService.setSignal({ [ctaAction]: true });
      if (actionNavigationConfigurations?.[ActionButtonOutcomesType.SUCCESS]) {
        handleRedirection(widgetProperties, injector, ActionButtonOutcomesType.SUCCESS, true, false);
      } else {
        alertHandlerService.showAlertFn('success', 'Joint account invitation accepted successfully');
      }
    },
    error: (error) => {
      console.error('Error accepting joint account invitation:', error);
      ctaButtonSignalService.setSignal({ [ctaAction]: true });
      if (actionNavigationConfigurations?.[ActionButtonOutcomesType.FAILURE]) {
        handleRedirection(widgetProperties, injector, ActionButtonOutcomesType.FAILURE, true, false);
      } else {
        alertHandlerService.showAlertFn('error', 'Failed to accept joint account invitation');
      }
    },
  });
}
